import request from '@/utils/request'; // 商品统计

export function getCommit(data) {
  return request({
    url: 'data/market_product',
    method: 'get',
    params: data
  });
}